import React from "react";
import { ILongerGameStatisticsProps } from "@/types/LongerStatisticsTypes";

import "./index.scss";

//Mimic m23 statistics
export default class M32 extends React.Component<ILongerGameStatisticsProps> {
	statisticsArray = [];
	
	filtrate(history: any) {
		//Counters
		let bankers = 0, players = 0, ties = 0,
			bankerSmalls = 0, playerSmalls = 0,
			bankerBigs = 0, playerBigs = 0,
			bankerOdds = 0, playerOdds = 0,
			bankerEvens = 0, playerEvens = 0;

		//Process history
		history.forEach((item: any) => {
			const winString = (item.result || item.win);
			if (winString === "player")
				players++;
			else if (winString === "banker")
				bankers++;
			else ties++;

			if (item.player_bs === "small")
				playerSmalls++;
			else playerBigs++;

			if (item.banker_bs === "small")
				bankerSmalls++;
			else bankerBigs++;

			if (item.player_oe === "odd")
				playerOdds++;
			else playerEvens++;

			if (item.banker_oe === "odd")
				bankerOdds++;
			else bankerEvens++;
		});

		//output into Statistics UI
		this.statisticsArray = [
			<tr key="sa1">
				<td>
					<div className="sl-roadmap-circle sl-roadmap-blue">
						<div className="sl-baccarat-bead-value">
							P
						</div>
					</div>
				</td>
				<td>
					<div className="sl-roadmap-circle sl-roadmap-red">
						<div className="sl-baccarat-bead-value">
							B
						</div>
					</div>
				</td>
				<td>
					<div className="sl-roadmap-circle sl-roadmap-green">
						<div className="sl-baccarat-bead-value">
							T
						</div>
					</div>
				</td>
				<td>
					<div className="sl-roadmap-circle-hollow sl-roadmap-blue">
						<div className="sl-baccarat-bead-value">
							O
						</div>
					</div>
				</td>
				<td>
					<div className="sl-roadmap-circle-hollow sl-roadmap-blue">
						<div className="sl-baccarat-bead-value">
							E
						</div>
					</div>
				</td>
				<td>
					<div className="sl-roadmap-circle-hollow sl-roadmap-red">
						<div className="sl-baccarat-bead-value">
							O
						</div>
					</div>
				</td>
				<td>
					<div className="sl-roadmap-circle-hollow sl-roadmap-red">
						<div className="sl-baccarat-bead-value">
							E
						</div>
					</div>
				</td>
				<td>
					<div className="sl-roadmap-circle sl-roadmap-blue">
						<div className="sl-baccarat-bead-value">
							B
						</div>
					</div>
				</td>
				<td>
					<div className="sl-roadmap-circle sl-roadmap-blue">
						<div className="sl-baccarat-bead-value">
							S
						</div>
					</div>
				</td>
				<td>
					<div className="sl-roadmap-circle sl-roadmap-red">
						<div className="sl-baccarat-bead-value">
							B
						</div>
					</div>
				</td>
				<td>
					<div className="sl-roadmap-circle sl-roadmap-red">
						<div className="sl-baccarat-bead-value">
							S
						</div>
					</div>
				</td>
			</tr>,
			<tr key="sa2">
				<td>
					<div>
						{ players }
					</div>
				</td>
				<td>
					<div>
						{ bankers }
					</div>
				</td>
				<td>
					<div>
						{ ties }
					</div>
				</td>


				<td>
					<div>
						{ playerOdds }
					</div>
				</td>
				<td>
					<div>
						{ playerEvens }
					</div>
				</td>
				
				<td>
					<div>
						{ bankerOdds }
					</div>
				</td>
				<td>
					<div>
						{ bankerEvens }
					</div>
				</td>
				
				<td>
					<div>
						{ playerBigs }
					</div>
				</td>
				<td>
					<div>
						{ playerSmalls }
					</div>
				</td>
				

				<td>
					<div>
						{ bankerBigs }
					</div>
				</td>
				<td>
					<div>
						{ bankerSmalls }
					</div>
				</td>
			</tr>
		];
	}

	render() {
		if (!this.props.history)
			return null;

		this.filtrate(this.props.history);
		
		const statisticsTable = (
			<table><tbody>
				{ this.statisticsArray }
			</tbody></table>
		);
		
		return (
			<div className={
					"game-statistics m32" +
					(this.props.baccaratDarkMode ? " dark" : "")
				}

				{...{pcode: this.props.pcode}}>

				{statisticsTable}
			</div>
		);
	}
}
